import React from 'react';
import { useQuery } from '@tanstack/react-query';
import Spinner from 'react-bootstrap/Spinner';
import AppLayout from 'components/App/CreateAccount/AppLayout';
import { getAccountCreateSettings, getParticipant } from 'api/account'
import { useBearerTokenContext, useTenantContext } from 'utilities/contexts';
import { useCreateAccountContext } from 'utilities/contexts.createAccount'


// Initialize app form data
export default function AppInit() {
    const bearer = useBearerTokenContext();
    const tenant = useTenantContext();
    const joinType = useCreateAccountContext().joinType; //Join, JoinToMerge, JoinFromGuid

    const accountCreateSettingsResult =  useQuery({
        queryKey: ['acountSettings', bearer, tenant], queryFn: () => getAccountCreateSettings(bearer, tenant),
        staleTime: Infinity // Reduce chattiness to server
    });

    const participantResult = useQuery({
        queryKey: ['participant', joinType, bearer, tenant], queryFn: () => getParticipant(joinType, bearer, tenant),
        staleTime: Infinity  
    });

    if (accountCreateSettingsResult.isLoading || participantResult.isLoading) {
        return (
            <div className="d-flex justify-content-center mt-5">
                <Spinner animation="border" role="status">
                    <span className="visually-hidden">Loading...</span>
                </Spinner>
            </div>
        );
    }

    if (accountCreateSettingsResult.isError || participantResult.isError) {
        return (
            <div className="d-flex justify-content-center mt-5">
                <span>Error in initialization. Try refreshing the page.</span>
            </div>
        );
    }

    return (        
            <AppLayout accountCreateSettings={accountCreateSettingsResult.data} participantPerson={participantResult.data} />        
    );
}